import debouncePromise from 'debounce-promise';
import { get, set } from 'lodash';
import { addressSelect } from '../../../../blocks/segments/address/address.events';
import { ERegions } from '../../../../../../shared/constants';
import validation from '../../../services/validation';

import { trackSelectKP } from './cottage-village-name.tracking';
import template from './cottage-village-name.jade';
import './typeahead-item.tpl.jade';
import './typeahead-popup.tpl.jade';

export default angular
  .module('cian.addForm.commonCottageVillageName', [])
  .directive('cianAfCommonCottageVillageName', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: [
      '$scope',
      '$rootScope',
      '$window',
      'apiService',
      'addressService',
      'deviceService',
      function ($scope, $rootScope, $window, apiService, addressService, deviceService) {
        this.validation = validation(this.form, 'cottageVillageName');
        this.isMobile = deviceService.isMobile;

        this.fieldValue = get(this, 'ad.kp.name');

        this.onBlur = () => {
          this.fieldValue = get(this, 'ad.kp.name');

          const kpId = get(this, 'ad.kp.id');
          if (!kpId) {
            this.form.cottageVillageName.$setValidity('remote', true);
          }
        };

        const selectKp = kp => {
          this.fieldValue = kp.name;
          set(this, 'ad.kp.name', kp.name);
          set(this, 'ad.kp.id', kp.id);
          trackSelectKP(kp.id);
          this.form.cottageVillageName.$setValidity('remote', true);
        };

        const getRegionId = () => {
          this.regionId = get(this, 'ad.geo.address[0].id') || this.regionId || ERegions.moscowRegion;

          return this.regionId;
        };

        this.getSuggestions = value => {
          if (value !== undefined && value !== get(this, 'ad.kp.name')) {
            set(this, 'ad.kp', null);
          }

          return apiService
            .getVillageSuggests({
              name: value,
              regionId: getRegionId(),
              locations: (this.ad.geo.details || [])
                .map(({ id, locationTypeId }) => (id && locationTypeId ? { id, type_id: locationTypeId } : null))
                .filter(Boolean),
            })
            .then(suggests => suggests.slice(0, 6));
        };

        this.getSuggestionsDebounced = debouncePromise(this.getSuggestions, 300);

        this.hasAddressChangedFromKPSuggest = false;

        this.selectSuggest = item => {
          apiService
            .geocode({
              params: {
                request: item.address,
                category: this.ad.category,
              },
            })
            .then(response => {
              if (response && response.data && response.data.data) {
                const geoDataByKP = response.data.data;
                const geoDetailsByKP = geoDataByKP.details.filter(d => d.geoType === 'location');
                const geoDetailsByAddress = (this.ad.geo.details || []).filter(d => d.geoType === 'location');

                if (
                  geoDetailsByKP.length > geoDetailsByAddress.length ||
                  geoDetailsByKP.some(({ id }, index) => id !== geoDetailsByAddress[index].id)
                ) {
                  this.ad.geo.userInput = geoDataByKP.text;
                  this.hasAddressChangedFromKPSuggest = true;
                  $rootScope.$emit(addressSelect);
                }
              }
            });
          selectKp(item);
        };

        addressService.onAddressChanged((address, geoObject, isValid, locationChanged, init, isJk, firstLoad) => {
          if (init || firstLoad) {
            return;
          }
          this.getSuggestions().then(suggests => {
            const currentKpId = get(this, 'ad.kp.id');

            const foundKp = suggests.find(s => s.id === currentKpId);
            const firstRealKp = suggests.find(s => s.isKp); // КП, который по геолокации является именно КП, а не деревней и пр.
            const kp = foundKp || firstRealKp;

            const isKp = !!kp && kp.isKp;

            // Если выбрана локация с таким же КП, то ничего не делаем
            if (kp && kp.id === currentKpId) {
              this.hasAddressChangedFromKPSuggest = false;

              return;
            }

            /*
            Делаем автовыбор КП в случае, если новый саджест является КП по его геолокации
          */
            if (isKp) {
              selectKp(kp);
            } else if (!this.hasAddressChangedFromKPSuggest) {
              set(this, 'ad.kp', null);
              this.fieldValue = '';
            }

            this.hasAddressChangedFromKPSuggest = false;
          });
        });
      },
    ],
    controllerAs: 'cottageVillageName',
    template,
  })).name;
